"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var close_icon_svg_1 = __importDefault(require("res/img/close-icon.svg"));
var help_icon_svg_1 = __importDefault(require("res/img/help-icon.svg"));
var view_icon_svg_1 = __importDefault(require("res/img/view-icon.svg"));
var EditProductAttachments = function (_a) {
    var attachments = _a.attachments, onDelete = _a.onDelete, onChangeOrder = _a.onChangeOrder, onUpload = _a.onUpload, busy = _a.busy;
    var _b = react_1.useState(attachments), data = _b[0], setData = _b[1];
    var _c = react_1.useState(attachments.length > 0 && attachments[0] || null), active = _c[0], setActive = _c[1];
    var grabbedRef = react_1.useRef(null);
    var cloneRefs = react_1.useRef(attachments.map(function () { return react_1.default.createRef(); }));
    var deleteHandler = function (attachment) {
        onDelete(attachment);
    };
    var previewHandler = function (attachment) {
        window.open(attachment.filepath, '_blank').focus();
    };
    var compare = function (a, b) {
        if (a.displayOrder < b.displayOrder)
            return -1;
        if (a.displayOrder > b.displayOrder)
            return 1;
        return 0;
    };
    return (react_1.default.createElement("div", { className: 'edit-product__page edit-product-gallery' },
        react_1.default.createElement("span", { className: 'title' }, "Product Attachments"),
        react_1.default.createElement("div", { className: 'help flex flex-row' },
            react_1.default.createElement("img", { src: help_icon_svg_1.default, alt: 'Help' }),
            react_1.default.createElement("p", null, "Upload or delete product attachments.")),
        react_1.default.createElement("div", { className: 'edit-product-gallery__content' },
            react_1.default.createElement("div", { className: 'edit-attachment_upload' },
                react_1.default.createElement("span", null,
                    "Select a file to upload",
                    react_1.default.createElement("label", { htmlFor: "upload-attachment" }, "Browse"),
                    react_1.default.createElement("input", { id: "upload-attachment", type: 'file', name: 'attachment', accept: 'application/pdf', multiple: true, onChange: onUpload }))),
            react_1.default.createElement("div", { className: "" }, attachments.slice().sort(compare).map(function (attachment, i) { return (react_1.default.createElement("div", { ref: cloneRefs.current[i], key: attachment.id, "data-id": attachment.id, className: 'edit-attachment__row flex flex-row full', "data-order": attachment.displayOrder },
                react_1.default.createElement("span", { className: "name" }, attachment.fileName),
                react_1.default.createElement("span", { className: "preview" },
                    react_1.default.createElement("button", { type: 'button', "aria-label": 'Delete Image', onClick: function () { return previewHandler(attachment); }, className: 'flex flex-center', title: 'Delete Image' },
                        react_1.default.createElement("img", { src: view_icon_svg_1.default, alt: 'Preview' }),
                        "Preview")),
                react_1.default.createElement("span", { className: "delete" },
                    react_1.default.createElement("button", { type: 'button', "aria-label": 'Delete Image', onClick: function () { return deleteHandler(attachment); }, className: 'flex flex-center', title: 'Delete Attachment' },
                        react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Delete' }),
                        " Delete")))); })))));
};
exports.default = EditProductAttachments;
